import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { CONSENT_EVENT, getAnalyticsConsent, setAnalyticsConsent } from '../../mixpanel/config';

export const OPEN_PRIVACY_EVENT = 'open-privacy-settings';
export default function PrivacyControls() {
  const [open, setOpen] = useState(() => getAnalyticsConsent() === null);
  const heading = useRef(null);
  const returnFocus = useRef(null);
  useEffect(() => {
    const show = () => {
      returnFocus.current = document.activeElement;
      setOpen(true);
      requestAnimationFrame(() => heading.current?.focus());
    };
    const sync = () => setOpen(getAnalyticsConsent() === null);
    window.addEventListener(OPEN_PRIVACY_EVENT, show);
    window.addEventListener(CONSENT_EVENT, sync);
    return () => {
      window.removeEventListener(OPEN_PRIVACY_EVENT, show);
      window.removeEventListener(CONSENT_EVENT, sync);
    };
  }, []);
  function choose(value) {
    setAnalyticsConsent(value);
    setOpen(false);
    returnFocus.current?.focus();
  }
  if (!open) return null;
  return (
    <section aria-labelledby="privacy-heading" className="fixed bottom-0 inset-x-0 z-50 border-t border-apple-gray-300 bg-white shadow-lg p-4 sm:p-6 max-h-[70vh] overflow-y-auto">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-4 md:items-center">
        <div className="flex-1">
          <h2 id="privacy-heading" ref={heading} tabIndex={-1} className="font-semibold text-apple-gray-800">Your privacy choices</h2>
          <p className="text-sm text-apple-gray-600 mt-1">With your permission, Mixpanel helps me understand page visits and link clicks. Analytics stay off unless you accept. You can change your choice in the footer. <Link className="underline" to="/privacy">Privacy notice</Link></p>
        </div>
        <div className="flex flex-wrap gap-3">
          <button onClick={() => choose('rejected')} className="border border-apple-gray-800 rounded-lg px-4 py-3 font-medium text-apple-gray-800">Reject analytics</button>
          <button onClick={() => choose('accepted')} className="border border-apple-gray-800 rounded-lg px-4 py-3 font-medium text-apple-gray-800">Accept analytics</button>
        </div>
      </div>
    </section>
  );
}
